import styled from '@emotion/styled';

export const TitleBtnBox = styled.div`
  display: flex;
  gap: 0 4px;
`;
